// Avoiding circular dependencies
export enum DatePickerType {
  single = "single",
  range = "range",
}

export enum TimePickerType {
  single = "single",
  range = "range",
}
